import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import React, { useMemo } from "react";

export default function Highlights({
  sx,
  name,
  options,
  onChange,
  label = "",
  placeHolder = "",
  value = "",
  keyColName = "",
  isError = false,
  errorText = " ",
  disabled,
  filterOptions,
}) {

  const [searchValue, setSearchValue] = React.useState("");

  const filteredList = useMemo(() => {

    if (!searchValue || searchValue.trim() === "") {
      return options.slice(0, 100);
    }

    const optionsFilter = options.filter((row) =>
      row.name.toLowerCase().includes(searchValue.toLowerCase())
    );
    return optionsFilter.slice(0, 100);
  }, [options, searchValue]);

  return (
    <Autocomplete
      id={name}
      sx={sx}
      size="small"
      options={filteredList}
      filterOptions={(x) => x}
      getOptionLabel={(option) => option && option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeHolder}
          variant="standard"
          margin="0px"
          // label={label}
          error={isError}
          helperText={errorText}
        />
      )}
      name={name}
      onChange={(event, newValue) => {
        onChange(name, newValue && newValue.id, newValue);
        // setValue(newValue);
      }}
      disabled={disabled}
      value={
        keyColName &&
          options.filter((item) => item[keyColName] === value).length > 0
          ? options.filter((item) => item[keyColName] === value)[0]
          : null
      }
      renderOption={(props, option, { inputValue }) => {
        const matches = match(option.name, inputValue);
        const parts = parse(option.name, matches);

        return (
          <li {...props} key={option.id || option.name}>
            <div>
              {parts.map((part, index) => (
                <span
                  key={index}
                  style={{
                    fontWeight: part.highlight ? 700 : 400,
                  }}
                >
                  {part.text}
                </span>
              ))}
            </div>
          </li>
        );
      }}
      onInputChange={(event, newInputValue, reason) => {
        if (reason === "input") {
          setSearchValue(newInputValue);
        } else if (reason === "reset") {
          setSearchValue("");
        }
      }}
    />
  );
}
